<template>
<div class="progress-bar">
  <div class="background">
  </div>
  <div class="foreground" v-bind:style="{ width: (progress * 100) + '%' }">
  </div>
</div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~@/styles/defaults.scss';

.progress-bar {
  height: 4px;
}

.background {
  width: 100%;
  height: 100%;
  background-color: rgba($brand-primary, 0.5);
  position: relative;
  top: 0;
  left: 0;
}

.foreground {
  height: 100%;
  width: 50%;
  background-color: $brand-primary;
  position: relative;
  top: -100%;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/progress-bar.vue